import React from 'react';
import { ApiCalls, emptyResponseData, IYachtData, IYachtResponseData } from '../../ApiCalls';
import { useSelector } from 'react-redux';
import { selectedYachtState } from '../../redux/slices/yachtSlice';
import { ReduxUpdater } from '../../redux/ReduxUpdater';
// import YachtLine from './elements/YachtLine';
// import TablePagination from './elements/TablePagination';
import { Column, DataTable } from './elements/Forms/DataTable';
import { GlobalStyles } from '../../GlobalStyles';
import { GlobalConstants } from '../../GlobalConstants';

const FleetContent = () => {
    const currentSelectedYachtState = useSelector(selectedYachtState);
    const [crewMembers, setCrewMembers] = React.useState(-1);
    const [crewCards, setCrewCards] = React.useState(-1);

    React.useEffect(() => {
        console.log('currentSelectedYachtState', currentSelectedYachtState);
        ReduxUpdater.selectedNavPos = 0;
        if (currentSelectedYachtState === null) {
            return;
        }

        setCrewMembers(-1);
        setCrewCards(-1);
        ApiCalls.crew(currentSelectedYachtState.id).then(crew => {
            console.log('CrewMembers:', crew);
            if (crew.items.length === 0) {
                ReduxUpdater.yachtCrew = [];
                ReduxUpdater.selectedUser = null;
                setCrewMembers(0);
                setCrewCards(0);
                return;
            }
            ReduxUpdater.yachtCrew = crew.items;
            ReduxUpdater.selectedUser = [GlobalConstants.UserRole.STANDARD, GlobalConstants.UserRole.BASIC].includes(ReduxUpdater.authenticatedUser?.user_role ?? '')
                ? ReduxUpdater.authenticatedUser
                : (currentSelectedYachtState.id === ReduxUpdater.authenticatedUser?.yacht_id ? ReduxUpdater.authenticatedUser : ReduxUpdater.yachtCrewCards[0]);
            setCrewMembers(crew.items.length);
            setCrewCards(ReduxUpdater.yachtCrewCards.length);
        }).catch(err => console.error(err));

        ApiCalls.yachtCurrencies(currentSelectedYachtState.id).then(res => {
            console.log('YachtCurrencies:', res);
            if (!res) {
                ReduxUpdater.currentYachtCurrencies = [];
                return;
            }
            ReduxUpdater.currentYachtCurrencies = res.currencies;
        }).catch(err => console.error(err));
    }, [currentSelectedYachtState]);

    const [fleetData, setFleetData] = React.useState<IYachtResponseData>(emptyResponseData);
    const [fleetDataOffset, setFleetDataOffset] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(25);
    const [isDataLoading, setIsDataLoading] = React.useState(false);

    React.useEffect(() => {
        setIsDataLoading(true);
        ApiCalls.fleet(fleetDataOffset, pageSize).then(d => {
            setFleetData({...d});
            setIsDataLoading(false);
        }).catch(err => console.error(err));
    }, [fleetDataOffset, pageSize]);

    const handleSelect = (yacht: IYachtData) => {
        if (!currentSelectedYachtState || currentSelectedYachtState.name !== yacht.callsign) {
            ReduxUpdater.currentYacht = yacht;
        } else {
            ReduxUpdater.currentYacht = null;
        }
    };

    const COLUMNS: Column<IYachtData>[] = [
        {
            key: "name", label: "Name",
            width: "3fr",
            sortable: false,
            styles: {
                padding: '13px 16px'
            }
        },
        {
            key: "loa", label: "Length",
            width: "1fr",
            sortable: false,
        },
        {
            key: "type", label: "Type",
            width: "1fr",
            sortable: false,
        },
        {
            key: "action", label: "Action",
            width: "1fr",
            align: "center",
        },
    ];

    return (
        <div className="max-w-[1000px] self-stretch px-4 inline-flex flex-col justify-center items-start gap-1 fill-available">
            {currentSelectedYachtState &&
                <div className="self-stretch min-h-64 h-64 p-4 bg-colors-white rounded-lg inline-flex justify-start items-start overflow-hidden">
                    <div className="flex-1 self-stretch rounded-lg outline outline-1 outline-offset-[-1px] border-border-default flex justify-between items-center overflow-hidden">
                        <img
                            className="w-[350px] self-stretch p-2.5"
                            alt={currentSelectedYachtState.name}
                            src={`https://storage.googleapis.com/booking_docs/Other/MVP_Images/${currentSelectedYachtState.image_url}`}
                        />
                        <div className="flex-1 self-stretch p-4 bg-colors-white inline-flex flex-col justify-between items-start overflow-hidden">
                            <div className="flex flex-col justify-start items-start gap-2">
                                <div className="justify-start text-black text-2xl font-semibold font-['Inter']">{currentSelectedYachtState.name}</div>
                                <div className="justify-start text-black text-2xl font-semibold font-['Inter']">{currentSelectedYachtState.loa}</div>
                            </div>
                            <div className="flex flex-col justify-start items-start gap-2">
                                <div className="justify-start text-text-light text-base font-normal font-['Inter']">{currentSelectedYachtState.type}</div>
                                <div className="justify-start text-text-light text-base font-normal font-['Inter']">{crewMembers !== -1 ? crewMembers : crewMembers} crew</div>
                                <div className="justify-start text-text-light text-base font-normal font-['Inter']">{crewCards !== -1 ? crewCards : crewCards} cards</div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <DataTable<IYachtData>
                className='w-full mb-4'
                columns={COLUMNS}
                data={fleetData.items}
                pagination={{ page: fleetDataOffset, pageSize, total: fleetData.total }}
                loading={isDataLoading}
                onPageChange={setFleetDataOffset}
                onPageSizeChange={setPageSize}
                onRowClick={handleSelect}
                rowCss={(r, i) => currentSelectedYachtState?.callsign === r.callsign ? 'h-12 min-h-12 bg-gray-200' : 'h-12 min-h-12'}
                styles={GlobalStyles.DataTable.table}
            />
        </div>
    );
};

export default FleetContent;